export const TypeNameBlockCtaStickyWithQuestions = 'ParagraphCtaStickyInteractif';
